module.exports = __webpack_public_path__ + "static/media/video-1.32f02184.mp4";